export function _getInitials(name) {
    let nameArray = name.split(' ')
    let initials = nameArray[0].charAt(0) + nameArray[1].charAt(0)
    return initials
}
